export default __webpack_public_path__ + "static/media/directContact.295d06c6.png";